import { IconProps } from '../icon/types';
import { ButtonProps } from './types';

// Shared variant classes for light theme
export const variantClasses = {
  primary:
    'bg-brand-700 text-white hover:bg-brand-600 active:bg-brand-800 disabled:bg-neutral-0 disabled:text-neutral-300',
  secondary:
    'border border-border-400 bg-white text-neutral-900 hover:bg-powder-blue active:bg-cloud-whisper disabled:bg-neutral-0 disabled:text-neutral-300 disabled:border-neutral-300',
  tertiary:
    'bg-transparent border-none text-neutral-900 hover:underline hover:underline-offset-4  hover:text-neutral-700 disabled:text-neutral-300 disabled:no-underline',
  destructive: 'bg-red-100 text-white hover:bg-red-200 active:bg-red-300',
  success: 'bg-green-100 text-white hover:bg-green-200 active:bg-green-300',
};

export const themeVariantClasses = {
  primary: 'bg-white text-neutral-900 hover:bg-gray-200 active:bg-gray-300',
  secondary:
    'border border-gray-600 bg-gray-800 text-white hover:bg-gray-700 active:bg-gray-600',
  tertiary:
    'bg-transparent border-none text-white hover:underline hover:text-gray-400 disabled:text-gray-500',
  destructive: 'bg-red-700 text-white hover:bg-red-600 active:bg-red-800',
  success: 'bg-green-700 text-white hover:bg-green-600 active:bg-green-800',
};

// Size classes for buttons
export const sizeClasses = {
  small: 'px-[18px] py-2',
  medium: 'px-[18px] py-3',
  large: 'px-[18px] py-4',
};

export const reverseClasses: { [key: string]: string } = {
  true: 'flex-row-reverse',
  false: '',
};

export const disabledClasses = 'cursor-not-allowed opacity-50';

export function getButtonClasses({
  variant,
  sizes,
  theme,
  name,
  leftIcon,
  rightIcon,
  disabled,
}: ButtonProps) {
  const resolvedVariantClass =
    theme === 'light'
      ? variantClasses[variant!]
      : themeVariantClasses[variant!];

  const resolvedSizeClass = sizeClasses[sizes!] || sizeClasses['medium'];

  const iconOnlyPaddingClass = !name && (leftIcon || rightIcon) ? 'p-3' : '';

  return {
    resolvedVariantClass,
    resolvedSizeClass,
    iconOnlyPaddingClass,
  };
}

export function getPaddingClass({
  name,
  leftIcon,
  rightIcon,
}: {
  name?: string;
  leftIcon?: IconProps;
  rightIcon?: IconProps;
}) {
  return !name && (leftIcon || rightIcon)
    ? ''
    : leftIcon && rightIcon
      ? 'px-3'
      : leftIcon
        ? 'pl-3 pr-4.5'
        : rightIcon
          ? 'pl-4.5 pr-3'
          : 'px-4.5';
}
